import { WEEKLY_RANK } from '@/mocks/entertainment';
import SectionHeading from './SectionHeading';

const TYPE_COLORS: Record<string, string> = {
  演员: 'bg-primary-100 text-primary-700',
  歌手: 'bg-accent-100 text-accent-700',
  爱豆: 'bg-secondary-100 text-secondary-900',
};

const MEDAL: Record<number, string> = {
  1: 'text-secondary-500',
  2: 'text-foreground-400',
  3: 'text-accent-600',
};

export default function RankBoard() {
  return (
    <section id="rank" className="bg-accent-100/50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <SectionHeading
              eyebrow="每周人气榜"
              title="用热度说话的上榜人物"
              desc="综合一周热搜词频、上榜时长与全网讨论量生成的周度榜单，去掉营销水分，只呈现真实讨论热度。"
            />
            <div className="mt-2 flex flex-wrap gap-2.5">
              {['持续一周上榜', '综合热度归一化', '每周一更新'].map((s) => (
                <span
                  key={s}
                  className="inline-flex items-center gap-1.5 rounded-full bg-background-50 px-3.5 py-2 text-sm text-foreground-700"
                >
                  <i className="ri-check-line text-accent-600"></i>
                  {s}
                </span>
              ))}
            </div>
          </div>

          <div className="rounded-3xl border border-background-200/70 bg-background-50 p-5 md:p-6">
            <div className="flex flex-col gap-4">
              {WEEKLY_RANK.map((it) => (
                <div key={it.rank} className="flex items-center gap-3">
                  <span
                    className={`w-6 shrink-0 text-center font-heading text-lg font-extrabold ${
                      MEDAL[it.rank] || 'text-foreground-300'
                    }`}
                  >
                    {it.rank}
                  </span>
                  <div className="w-24 shrink-0">
                    <div className="flex items-center gap-1.5">
                      <h3 className="truncate font-heading text-sm font-bold text-foreground-950">
                        {it.name}
                      </h3>
                      <span
                        className={`shrink-0 rounded px-1.5 py-0.5 font-label text-[10px] font-medium ${
                          TYPE_COLORS[it.type] || 'bg-background-100 text-foreground-600'
                        }`}
                      >
                        {it.type}
                      </span>
                    </div>
                    <p className="truncate font-label text-[11px] text-foreground-500">
                      {it.reason}
                    </p>
                  </div>
                  <div className="h-2.5 flex-1 overflow-hidden rounded-full bg-background-100">
                    <div
                      className="h-full rounded-full bg-gradient-to-r from-secondary-400 via-primary-400 to-accent-400 transition-all duration-700"
                      style={{ width: `${it.heat}%` }}
                    ></div>
                  </div>
                  <span className="w-12 shrink-0 text-right font-heading text-sm font-bold text-foreground-900">
                    {it.heat}%
                  </span>
                  <span className="flex w-5 items-center justify-center">
                    {it.trend === 'up' && (
                      <i className="ri-arrow-up-line text-sm font-bold text-accent-600"></i>
                    )}
                    {it.trend === 'down' && (
                      <i className="ri-arrow-down-line text-sm font-bold text-primary-500"></i>
                    )}
                    {it.trend === 'same' && (
                      <i className="ri-arrow-right-line text-sm text-foreground-300"></i>
                    )}
                    {it.trend === 'new' && (
                      <i className="ri-sparkling-line text-sm text-primary-600"></i>
                    )}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}